import {
  ACTIVATE_TRAINER,
  ACTIVATE_TRAINER_SUCCESS,
  ADD_BULK_TRAINER,
  ADD_BULK_TRAINER_SUCCESS,
  ADD_TRAINER,
  ADD_TRAINER_SUCCESS,
  DEACTIVATE_TRAINER,
  DEACTIVATE_TRAINER_SUCCESS,
  DOWNLOAD_TRAINER_BULK_TEMPLATE,
  DOWNLOAD_TRAINER_BULK_TEMPLATE_SUCCESS,
  EMPTY_ALL_TRAINERS,
  EMPTY_TOTAL_TRAINERS,
  EMPTY_TRAINER_BY_ID,
  EMPTY_TRAINER_SELECT,
  EXPORT_TRAINERS,
  EXPORT_TRAINERS_SUCCESS,
  FETCH_ALL_TOTAL_TRAINERS_DETAILS,
  FETCH_ALL_TOTAL_TRAINERS_DETAILS_SUCCESS,
  FETCH_ALL_TRAINERS,
  FETCH_ALL_TRAINERS_SUCCESS,
  FETCH_TRAINER_BY_ID,
  FETCH_TRAINER_BY_ID_SUCCESS,
  FETCH_TRAINER_SELECT,
  FETCH_TRAINER_SELECT_SUCCESS,
  PRINT_TRAINERS,
  PRINT_TRAINERS_SUCCESS,
  RESTORE_TRAINER_INITIAL,
  UPDATE_TRAINER,
  UPDATE_TRAINER_SUCCESS,
  POST_APPROVAL_COMMENT,
  POST_APPROVAL_COMMENT_SUCCESS,

  // virtual approval
  VIRTUALLY_APPROVE_TRAINER,
  VIRTUALLY_APPROVE_TRAINER_SUCCESS,
  VIRTUALLY_APPROVE_TRAINER_FAILURE,
  RESET_VIRTUAL_APPROVAL_STATES,
  SAVE_CURRENT_TRAINER_ID,
  RESET_CURRENT_TRAINER_ID,

  FETCH_TRAINING_CENTER_FILE_BY_ID,
  FETCH_TRAINING_CENTER_FILE_BY_ID_SUCCESS,
  FETCH_TRAINING_CENTER_FILE_BY_ID_FAILURE,
  FETCH_TRAINING_CENTER_FILE_BY_ID_RESET,


  // training center report page
  FETCH_TRAINING_CENTER_REPORT,
  FETCH_TRAINING_CENTER_REPORT_SUCCESS,
  FETCH_TRAINING_CENTER_REPORT_FAILURE,

  PRINT_TRAINING_CENTER_REPORT,
  PRINT_TRAINING_CENTER_REPORT_SUCCESS,
  PRINT_TRAINING_CENTER_REPORT_FAILURE,
  RESET_PRINT_TRAINING_CENTER_REPORT,

  EXPORT_TRAINING_CENTER_REPORT,
  EXPORT_TRAINING_CENTER_REPORT_SUCCESS,
  EXPORT_TRAINING_CENTER_REPORT_FAILURE,
  RESET_EXPORT_TRAINING_CENTER_REPORT,
  FETCH_TRAINER_BY_EMAIL,
  FETCH_TRAINER_BY_EMAIL_SUCCESS,
  FETCH_TRAINER_BY_EMAIL_FAILURE,
  UPDATE_TRAINING_CENTER,
  UPDATE_TRAINING_CENTER_SUCCESS,
  UPDATE_TRAINING_CENTER_FAILURE,
  EMPTY_TRAINER_BY_EMAIL,

  EXPORT_VIRTUALLY_APPROVED_TRAINERS,
  EXPORT_VIRTUALLY_APPROVED_TRAINERS_SUCCESS,
  EXPORT_VIRTUALLY_APPROVED_TRAINERS_FAILURE,
  EXPORT_VIRTUALLY_APPROVED_TRAINERS_RESET,

} from "../ActionTypes"

export const addNewTrainer = (payload) => ({
  type: ADD_TRAINER,
  payload
})

export const addNewTrainerSuccess = (payload) => ({
  type: ADD_TRAINER_SUCCESS,
  payload
})

// to get all trainers

export const fetchTrainers = (payload) => ({
  type: FETCH_ALL_TRAINERS,
  payload
})

export const fetchTrainersSuccess = (payload) => ({
  type: FETCH_ALL_TRAINERS_SUCCESS,
  payload
})


export const emptyTrainers = () => ({
  type: EMPTY_ALL_TRAINERS
});

export const restoreTrainerInitial = () => ({
  type: RESTORE_TRAINER_INITIAL
});

// To Activate and Deactivate trainer
export const activateTrainer = (id) => ({
  type: ACTIVATE_TRAINER,
  payload: id
})

export const activateTrainerSuccess = (payload) => ({
  type: ACTIVATE_TRAINER_SUCCESS,
  payload
})

export const deactivateTrainer = (id) => ({
  type: DEACTIVATE_TRAINER,
  payload: id
})

// To post approval comment
export const postApprovalComment = (payload) => ({
  type: POST_APPROVAL_COMMENT,
  payload
});

export const approvalSuccess = (payload) => ({
  type: POST_APPROVAL_COMMENT_SUCCESS,
  payload
});

export const deactivateTrainerSuccess = (payload) => ({
  type: DEACTIVATE_TRAINER_SUCCESS,
  payload
})

// To fetch trainer by id
export const fetchTrainerById = (id) => ({
  type: FETCH_TRAINER_BY_ID,
  payload: id
})

export const fetchTrainerByIdSuccess = (payload) => ({
  type: FETCH_TRAINER_BY_ID_SUCCESS,
  payload
})

export const emptyTrainerById = () => ({
  type: EMPTY_TRAINER_BY_ID,
})

// To update trainer
export const updateTrainer = (payload) => ({
  type: UPDATE_TRAINER,
  payload
})
export const updateTrainerSuccess = (payload) => ({
  type: UPDATE_TRAINER_SUCCESS,
  payload
})

// To fetch all total trainer details
export const fetchAllTotalTrainersDetails = () => ({
  type: FETCH_ALL_TOTAL_TRAINERS_DETAILS,
})
export const fetchAllTotalTrainersDetailsSuccess = (payload) => ({
  type: FETCH_ALL_TOTAL_TRAINERS_DETAILS_SUCCESS,
  payload
})

export const emptyTotalTrainers = () => ({
  type: EMPTY_TOTAL_TRAINERS
});

// To export trainers
export const exportTrainers = () => ({
  type: EXPORT_TRAINERS,
})
export const exportTrainersSuccess = (payload) => ({
  type: EXPORT_TRAINERS_SUCCESS,
  payload
})

// To print trainers
export const printTrainersPdf = () => ({
  type: PRINT_TRAINERS
})
export const printTrainersPdfSuccess = payload => ({
  type: PRINT_TRAINERS_SUCCESS,
  payload
})

// To fetch all trainers without pagination
export const fetchTrainerSelect = () => ({
  type: FETCH_TRAINER_SELECT
});

export const fetchTrainerSelectSuccess = (payload) => ({
  type: FETCH_TRAINER_SELECT_SUCCESS,
  payload
});

export const emptyTrainerSelect = () => ({
  type: EMPTY_TRAINER_SELECT
});

// To download trainers bulk template
export const downloadBulkTrainer = () => ({
  type: DOWNLOAD_TRAINER_BULK_TEMPLATE,
})
export const downloadBulkTrainerSuccess = (payload) => ({
  type: DOWNLOAD_TRAINER_BULK_TEMPLATE_SUCCESS,
  payload
})

// To add bulk trainers
export const addBulkTrainer = (payload) => ({
  type: ADD_BULK_TRAINER,
  payload
})
export const addBulkTrainerSuccess = (payload) => ({
  type: ADD_BULK_TRAINER_SUCCESS,
  payload
})



// Virtual Approval
export const virtuallyApproveTrainer = payload => ({
  type: VIRTUALLY_APPROVE_TRAINER,
  payload
})

export const virtuallyApproveTrainerSuccess = payload => ({
  type: VIRTUALLY_APPROVE_TRAINER_SUCCESS,
  payload
})

export const virtuallyApproveTrainerFailure = payload => ({
  type: VIRTUALLY_APPROVE_TRAINER_FAILURE,
  payload
})

export const resetVirtualApprovalStates = () => ({
  type: RESET_VIRTUAL_APPROVAL_STATES
})

export const saveCurrentTrainerId = id => ({
  type: SAVE_CURRENT_TRAINER_ID,
  id
})

export const resetCurrentTrainerId = () => ({
  type: RESET_CURRENT_TRAINER_ID
})


export const fetchTrainingCenterReport = payload => ({
  type: FETCH_TRAINING_CENTER_REPORT,
  payload
})

export const fetchTrainingCenterReportSuccess = (payload) => ({
  type: FETCH_TRAINING_CENTER_REPORT_SUCCESS,
  payload
})

export const fetchTrainingCenterReportFailure = () => ({
  type: FETCH_TRAINING_CENTER_REPORT_FAILURE
})


export const fetchTrainingCenterFileById = (payload) => ({
  type: FETCH_TRAINING_CENTER_FILE_BY_ID,
  payload
})

export const fetchTrainingCenterFileByIdSuccess = (payload) => ({
  type: FETCH_TRAINING_CENTER_FILE_BY_ID_SUCCESS,
  payload
})

export const fetchTrainingCenterFileByIdFailure = (payload) => ({
  type: FETCH_TRAINING_CENTER_FILE_BY_ID_FAILURE,
  payload
})

export const fetchTrainingCenterFileByIdReset = (payload) => ({
  type: FETCH_TRAINING_CENTER_FILE_BY_ID_RESET,
  payload
})


// Print training center report
export const printTrainingCenterReport = (payload) => ({
  type: PRINT_TRAINING_CENTER_REPORT,
  payload
})

export const printTrainingCenterReportSuccess = (payload) => ({
  type: PRINT_TRAINING_CENTER_REPORT_SUCCESS,
  payload
})

export const printTrainingCenterReportFailure = (payload) => ({
  type: PRINT_TRAINING_CENTER_REPORT_FAILURE,
  payload
})

export const resetPrintTrainingCenterReport = () => ({
  type: RESET_PRINT_TRAINING_CENTER_REPORT,
})


// export training center report
export const exportTrainingCenterReport = (payload) => ({
  type: EXPORT_TRAINING_CENTER_REPORT,
  payload
})

export const exportTrainingCenterReportSuccess = (payload) => ({
  type: EXPORT_TRAINING_CENTER_REPORT_SUCCESS,
  payload
})

export const exportTrainingCenterReportFailure = (payload) => ({
  type: EXPORT_TRAINING_CENTER_REPORT_FAILURE,
  payload
})

export const resetExportTrainingCenterReport = () => ({
  type: RESET_EXPORT_TRAINING_CENTER_REPORT
})

// To fetch all trainer by email
export const fetchTrainerByEmail = (payload) => ({
  type: FETCH_TRAINER_BY_EMAIL,
  payload,
});

export const fetchTrainerByEmailSuccess = (payload) => ({
  type: FETCH_TRAINER_BY_EMAIL_SUCCESS,
  payload,
});

export const fetchTrainerByEmailFailure = (payload) => ({
  type: FETCH_TRAINER_BY_EMAIL_FAILURE,
  payload,
});
export const emptyTrainerByEmail = () => ({
  type: EMPTY_TRAINER_BY_EMAIL,
});

// To update training center
export const updateTrainingCenter = (payload) => ({
  type: UPDATE_TRAINING_CENTER,
  payload
})

export const updateTrainingCenterSuccess = (payload) => ({
  type: UPDATE_TRAINING_CENTER_SUCCESS,
  payload
})

export const updateTrainingCenterFailure = (payload) => ({
  type: UPDATE_TRAINING_CENTER_FAILURE,
  payload
})

// To download virtual approval report
export const exportVirtuallyApprovedTrainers = payload => ({
  type: EXPORT_VIRTUALLY_APPROVED_TRAINERS,
  payload
})

export const exportVirtuallyApprovedTrainersSuccess = payload => ({
  type: EXPORT_VIRTUALLY_APPROVED_TRAINERS_SUCCESS,
  payload
})

export const exportVirtuallyApprovedTrainersFailure = payload => ({
  type: EXPORT_VIRTUALLY_APPROVED_TRAINERS_FAILURE,
  payload
})

export const exportVirtuallyApprovedTrainersReset = payload => ({
  type: EXPORT_VIRTUALLY_APPROVED_TRAINERS_RESET,
  payload
})



